import EditQuestionsAnswers from '@/common/containers/EditQuestionsAnswers/EditQuestionsAnswers';

export default EditQuestionsAnswers;
